import SEO from "@/components/common/seo/seo";
import Footer from "../../components/common/layout/Footer";
import { PrivacyPolicyContent, Breadcrumbs } from "@/components/features/privacypolicy";

export default function Support() {
  return (
    <div>
       <SEO
          title="Privacy Policy - SAN micron"
          description="Learn how SAN micron collects, uses, and protects your personal information in accordance with our privacy policy."
        />
      <Breadcrumbs />
      <PrivacyPolicyContent />
      <Footer />
    </div>
  )
}